/**
 * Setup a set of warnings to ignore in the console.
 *
 * This overrides the default console.warn method to filter out specific warning messages.
 *
 * @param warnings - An array of warning messages to ignore. These are partial messages, meaning that if a logged warning contains any of these strings, it will be ignored.
 */
export function setupFilterConsoleWarnings(warnings: string[]): void {
  const originalWarn = console.warn;
  console.warn = function consoleWarn(message?: unknown, ...optionalParams: unknown[]) {
    if (typeof message === "string" && warnings.some((warning) => message.includes(warning))) {
      return;
    }
    originalWarn.call(window.console, message, ...optionalParams);
  };
}
